/* eslint-disable import/prefer-default-export */

// Generate random css hex color value
export const generateRandomHexColor = () => `#${Math.floor(Math.random() * 16777215).toString(16)}`
